import  Color from  'color'

export const checkBackgroundTextContrast = (color: string, contrastText: string) => {
    const colorObj = Color(color);
    const textColorObj = Color(contrastText);
    if(colorObj.contrast(textColorObj) < 1.97) {
        return false
    }
    return true
}